import React from 'react';
import PropTypes from 'prop-types';
import isObject from 'lodash.isobject';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const InterpLevelTitle = ({ levelTitle, levelTypeTitle }) => (
    <div className="perfomance-cell interp">
        {levelTitle && (
            <>
                {levelTitle}
                <br />
            </>
        )}
        {levelTypeTitle}
    </div>
);

InterpLevelTitle.defaultProps = {
    levelTitle: '',
    levelTypeTitle: '',
};

InterpLevelTitle.propTypes = {
    levelTitle: PropTypes.string,
    levelTypeTitle: PropTypes.string,
};

const PerformanceRow = ({ level, levelTitle, levelTypeTitle, performance }) => {
    return (
        <div key={level} className={`${level} row`}>
            <InterpLevelTitle levelTitle={levelTitle} levelTypeTitle={levelTypeTitle} />
            {performance.map((result, index) => {
                if (isObject(result)) {
                    const { percentage, studentsTotalNumber } = result;
                    const studentsText = studentsTotalNumber === 1 ? ' Student' : ' Students';

                    return (
                        <div
                            key={generateReactKey(index)}
                            className="perfomance-cell"
                            data-test-id="students-data"
                        >
                            <span className="students-info">{percentage}%</span>
                            {studentsTotalNumber}
                            {studentsText}
                        </div>
                    );
                }

                return (
                    <div key={generateReactKey(index)} className="perfomance-cell">
                        {result}
                    </div>
                );
            })}
        </div>
    );
};

PerformanceRow.defaultProps = {
    levelTitle: '',
    levelTypeTitle: '',
};

PerformanceRow.propTypes = {
    levelTitle: PropTypes.string,
    levelTypeTitle: PropTypes.string,
    performance: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string]))
        .isRequired,
    level: PropTypes.string.isRequired,
};

export default PerformanceRow;
